import { render, staticRenderFns } from "./DialogAuthorizationMyAcuvue.vue?vue&type=template&id=07d5342a&scoped=true&"
import script from "./DialogAuthorizationMyAcuvue.vue?vue&type=script&lang=js&"
export * from "./DialogAuthorizationMyAcuvue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5342a",
  null
  
)

export default component.exports